const style = {
  container: (provided) => ({ ...provided }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: '0 0 0 1px transparent',
    backgroundColor: '#B5E0DC',
    borderColor: 'transparent',
    '&:hover': {
      borderColor: state.isFocused ? 'transparent' : '',
    },
  }),
  placeholder: (provided) => ({ ...provided, fontSize: '14px', fontWeight: 'bold' }),
  valueContainer: (provided) => ({ ...provided }),
  singleValue: (provided) => ({ ...provided, fontSize: '14px', fontWeight: 'bold' }),
  multiValue: (provided) => ({ ...provided, fontSize: '14px', fontWeight: 'bold' }),
  multiValueLabel: (provided) => ({ ...provided }),
  multiValueRemove: (provided) => ({ ...provided }),
  input: (provided) => ({
    ...provided,
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#192243',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: 'bold',
    backgroundColor: state.isSelected ? '#00122C' : '',
    '&:hover': {
      backgroundColor: '#B5E0DC',
      color: '#192243',
    },
  }),
  clearIndicator: (provided) => ({ ...provided }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorContainer: (provided) => ({ ...provided }),
};

export default style;
